import React from 'react';
export const WixDesignSystemContext = React.createContext({
    newColorsBranding: false,
    newBrandingClass: 'no-brand',
});
//# sourceMappingURL=context.js.map